export default __webpack_public_path__ + "static/media/sphers-smm.c28d91e6.svg";